let token: string | null;

try {
  token = document.getElementsByName('csrf-token')[0].getAttribute('content');
} catch {
  token = null;
}

/**
 * Retrieves the CSRF Token from the page
 */
export default function getCsrfToken(): string | null {
  return token;
}
